var Footer, Header, m;

m = require('mithril');

Header = require('./Header');

Footer = require('./Footer');

module.exports = {
  view: function(ctrl, args) {
    var ref;
    return m('.page', [
      m(Header, {
        account: args.account
      }), (ref = args.content) != null ? ref : [], m(Footer)
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9QYWdlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3VpL2NvbXBvbmVudHMvUGFnZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBQ0osTUFBQSxHQUFTLE9BQUEsQ0FBUSxVQUFSOztBQUNULE1BQUEsR0FBUyxPQUFBLENBQVEsVUFBUjs7QUFFVCxNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixJQUFBLEVBQU0sU0FBQyxJQUFELEVBQU8sSUFBUDtBQUNMLFFBQUE7V0FBQSxDQUFBLENBQUUsT0FBRixFQUFXO01BQ1YsQ0FBQSxDQUFFLE1BQUYsRUFBVTtRQUFDLE9BQUEsRUFBUyxJQUFJLENBQUMsT0FBZjtPQUFWLENBRFUsdUNBRUssRUFGTCxFQUdWLENBQUEsQ0FBRSxNQUFGLENBSFU7S0FBWDtFQURLLENBRFUifQ==
